import { render, staticRenderFns } from "./accordion.pug?vue&type=template&id=aca6fc2a&lang=pug&external"
import script from "./accordion.js?vue&type=script&lang=js&external"
export * from "./accordion.js?vue&type=script&lang=js&external"
import style0 from "./accordion.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca6fc2a')) {
      api.createRecord('aca6fc2a', component.options)
    } else {
      api.reload('aca6fc2a', component.options)
    }
    module.hot.accept("./accordion.pug?vue&type=template&id=aca6fc2a&lang=pug&external", function () {
      api.rerender('aca6fc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accordion/index.vue"
export default component.exports